import React from "react";
import styled from "styled-components";

const HAspectRatio = styled.div`
  position: relative;
  width: ${({ width }) => width};
  padding-top: ${({ aspect }) => aspect * 100 + "%"}};
`;

const VAspectRatio = styled.div`
  position: relative;
  height: ${({ height }) => height};
  padding-left: ${({ aspect }) => aspect * 100 + "%"}};
`;

const Image = styled.div`
  background: url(${({ src }) => src}) no-repeat center;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
export default ({
  children,
  width = "100%",
  height = "100%",
  aspect = 0.5,
  src,
  direction = "horizontal",
  style = {}
}) => {
  return direction === "horizontal"
    ? <HAspectRatio width={width} aspect={aspect} style={style}>
        <Image src={src} />
        {children}
      </HAspectRatio>
    : <VAspectRatio height={height} aspect={aspect} style={style}>
        <Image src={src} />
        {children}
      </VAspectRatio>;
};



// WEBPACK FOOTER //
// ./src/components/atoms/AspectImage.js